import { render, staticRenderFns } from "./loginServicesTg.vue?vue&type=template&id=bca7294e&scoped=true"
import script from "./loginServicesTg.vue?vue&type=script&lang=js"
export * from "./loginServicesTg.vue?vue&type=script&lang=js"
import style0 from "./loginServicesTg.vue?vue&type=style&index=0&id=bca7294e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca7294e",
  null
  
)

export default component.exports